import axios from './config/axios'

export const getAvailableIntegrations = () => axios.get('/available-integrations')
export const deleteIntegration = (service) => axios.delete('/integrations/' + service)
export const createIntegration = (service, data) => axios.post('/integrations/' + service, data)
